import { template as template_7246597cf9b44d12b12a53ee1c87a21c } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import getDelayTime from 'eflex/util/get-delay-time';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';
import { all, task, timeout } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import DraggableObjectTarget from '@eflexsystems/ember-drag-drop/components/draggable-object-target';
import { includes } from '@eflexsystems/ember-composable-helpers';
import WorkInstructionEditorLibraryCard from 'eflex/components/work-instruction-editor/library-card';
import { eq, and } from 'ember-truth-helpers';
import { keyResponder } from 'ember-keyboard';
@keyResponder
class WorkInstructionEditorLibraryThumbView extends Component {
    @service
    workInstructionRepo;
    @service
    hostedFileRepo;
    @tracked
    isDragging = false;
    scrollingActive = false;
    #scrollContainerSelector = '.library-scroll-container';
    scrollTime = getDelayTime(600);
    _dragScroll = task(waitFor(async (scrollAmount)=>{
        while(this.scrollingActive){
            // eslint-disable-next-line ember/no-jquery
            $(this.#scrollContainerSelector).animate({
                scrollTop: scrollAmount
            }, this.scrollTime);
            await timeout(this.scrollTime);
        }
    }));
    scrollDown = task({
        drop: true
    }, waitFor(async ()=>{
        this.scrollingActive = true;
        await this._dragScroll.perform('+=300px');
    }));
    scrollUp = task({
        drop: true
    }, waitFor(async ()=>{
        this.scrollingActive = true;
        await this._dragScroll.perform('-=300px');
    }));
    stopScroll = task(waitFor(async ()=>{
        this.scrollingActive = false;
        await all([
            this._dragScroll.cancelAll({
                resetState: true
            }),
            this.scrollDown.cancelAll({
                resetState: true
            }),
            this.scrollUp.cancelAll({
                resetState: true
            })
        ]);
    }));
    willDestroy() {
        super.willDestroy(...arguments);
        // eslint-disable-next-line ember/no-jquery
        $(this.#scrollContainerSelector).clearQueue();
    }
    libraryCardDraggable = (libraryItem)=>{
        return this.workInstructionRepo.userCanEdit(libraryItem);
    };
    dropOnFolder = (folder, libraryItem)=>{
        this.isDragging = false;
        this.args.dropOnFolder(folder, libraryItem);
    };
    static{
        template_7246597cf9b44d12b12a53ee1c87a21c(`
    <DraggableObjectTarget
      @onDragOver={{this.scrollUp.perform}}
      @onDragOut={{this.stopScroll.perform}}
      @action={{this.stopScroll.perform}}
    >
      <div
        class="
          drag-scroll-target
          at-top
          {{if this.isDragging "is-active"}}
          component-drag-scroll-container
        "
      ></div>
    </DraggableObjectTarget>

    <div class="flex-fill {{if @isModal "px-4"}}">
      <div class="library-contents-inner row g-3 flex-wrap thumb-view">
        {{#if @selectedFolder}}
          <div class="test-library-item-wrapper {{if @isModal "col-4" "col-4 col-lg-3 col-xl-2"}}">
            <WorkInstructionEditorLibraryCard
              class="test-return-to-root-folder"
              @isReadOnly={{@isReadOnly}}
              @dropOnFolder={{fn this.dropOnFolder null}}
              {{on "click" (fn @loadFolder null)}}
            />
          </div>
        {{/if}}
        {{#each @selectableFolders as |folder|}}
          <div class="test-library-item-wrapper {{if @isModal "col-4" "col-4 col-lg-3 col-xl-2"}}">
            <WorkInstructionEditorLibraryCard
              @libraryItem={{folder}}
              @dropOnFolder={{fn this.dropOnFolder folder}}
              @isReadOnly={{@isReadOnly}}
              @saveFolder={{fn @saveFolder folder}}
              @isSelected={{includes folder @selectedCards}}
              @delete={{@delete}}
              @edit={{@edit}}
              @open={{@open}}
              @folderSettings={{@folderSettings}}
              @isMultiselectMode={{@isMultiselectMode}}
              @selectedCards={{@selectedCards}}
              {{on "click" (fn @cardSelected folder)}}
              {{on "dblclick" (fn @loadFolder folder)}}
            />
          </div>
        {{/each}}
        {{#each @selectableLibraryItems as |libraryItem|}}
          <div class="test-library-item-wrapper
            {{if @isModal "col-4" "col-4 col-lg-3 col-xl-2"}}
          ">
            <WorkInstructionEditorLibraryCard
              @libraryItem={{libraryItem}}
              @isReadOnly={{@isReadOnly}}
              @isSelected={{includes libraryItem @selectedCards}}
              @isActive={{eq libraryItem.id @currentWorkInstruction.id}}
              @deselectAll={{@deselectAll}}
              @startDrag={{fn (mut this.isDragging) true}}
              @endDrag={{fn (mut this.isDragging) false}}
              @isDraggable={{fn this.libraryCardDraggable libraryItem}}
              @moveToFolder={{@moveToFolder}}
              @delete={{@delete}}
              @replace={{@replace}}
              @edit={{@edit}}
              @export={{@export}}
              @disabled={{and @isModal (eq @currentWorkInstruction libraryItem)}}
              @isModal={{@isModal}}
              @isMultiselectMode={{@isMultiselectMode}}
              @selectedFolder={{@selectedFolder}}
              @selectedCards={{@selectedCards}}
              {{on "click" (fn @cardSelected libraryItem)}}
              {{on "dblclick" (fn @cardDoubleClick libraryItem)}}
            />
          </div>
        {{/each}}
      </div>
    </div>

    <DraggableObjectTarget
      @onDragOver={{this.scrollDown.perform}}
      @onDragOut={{this.stopScroll.perform}}
      @action={{this.stopScroll.perform}}
    >
      <div
        class="
          drag-scroll-target
          at-bottom
          {{if this.isDragging "is-active"}}
          component-drag-scroll-container
        "
      ></div>
    </DraggableObjectTarget>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
export default WorkInstructionEditorLibraryThumbView;
